import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table/columns";
import selectColumnFactory from "@/react/components/table/components/selectColumnFactory";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import { PHONE_CHANNEL_FORMATS } from "./constants";
import { PhoneChannelFormatCell } from "./PhoneChannelFormatCell";
import FormatColumnSetter from "./FormatColumnSetter";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      { ...getColumnDef(schema.fields.id, "ID") },
      {
        ...getColumnDef(schema.fields.name, "Name"),
        customCell: ({ getValue }) => <strong>{getValue()}</strong>,
        editable: true,
        sticky: true,
      },
      {
        ...getColumnDef(schema.fields.is_enabled, "Enabled"),
        editable: true,
        type: TYPES.BOOLEAN,
      },
      {
        ...getColumnDef(schema.fields.uuid, "UUID"),
      },
      {
        ...getColumnDef(schema.fields.number, "Number"),
      },
      {
        ...getColumnDef(schema.fields.format, "Format"),
        editableCell: PhoneChannelFormatCell,
        editable: true,
        columnSetter: FormatColumnSetter,
        type: TYPES.SELECT,
        options: Object.fromEntries(
          PHONE_CHANNEL_FORMATS.map((phoneChannelFormat) => [
            phoneChannelFormat,
            phoneChannelFormat,
          ])
        ),
      },
      {
        ...getColumnDef(schema.fields.type, "Type"),
      },
      {
        ...getColumnDef(schema.fields.calling_name, "Calling Name"),
      },
      {
        ...getColumnDef(schema.fields.linked_agent, "Linked Agent"),
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.ivr_script_id, "IVR Script ID"),
        editable: true,
      },
    ].map(mapColumnTypes)
  );

export default columnDefinition;
